export const normalizeString = (string: string) =>
	string.replace(/\s+/g, '').toLowerCase();
